<template>
    <b-overlay :show="busySaving">
        <b-form @submit.prevent="saveClientForm">
            <b-row> </b-row>
            <b-row class="mb-2">
                <b-col cols="12" md="6">
                    <label class="mb-0" for="">Company name:</label>
                    <b-form-input
                        id="company_name"
                        size="sm"
                        type="text"
                        v-model="$v.form.company_name.$model"
                        :state="validateState('company_name')"
                        aria-describedby="company_name-live-feedback"
                    ></b-form-input>
                    <b-form-invalid-feedback v-if="formSubmit" id="ccompany_name-1-live-feedback">
                        This is a required field and must be at least 3 characters.
                    </b-form-invalid-feedback>
                </b-col>
                <b-col cols="12" md="6">
                    <label class="mb-0" for="">Contact Person:</label>
                    <b-form-input
                        id="contact_person"
                        size="sm"
                        type="text"
                        v-model="$v.form.contact_person.$model"
                        :state="validateState('contact_person')"
                        aria-describedby="contact-person-live-feedback"
                    ></b-form-input>
                    <b-form-invalid-feedback v-if="formSubmit" id="contact-person-1-live-feedback"
                        >This is a required field and must be at least 3 characters.
                    </b-form-invalid-feedback>
                </b-col>
            </b-row>
            <b-row class="mb-2">
                <b-col cols="12" md="6">
                    <label class="mb-0" for="">Contact No:</label>
                    <b-form-input
                        id="contact-no"
                        size="sm"
                        type="text"
                        v-model="$v.form.contact_no.$model"
                        :state="validateState('contact_no')"
                        aria-describedby="contact-no-live-feedback"
                    ></b-form-input>
                    <b-form-invalid-feedback v-if="formSubmit" id="contact-no-1-live-feedback"
                        >This is a required field and must be at least 3 characters.
                    </b-form-invalid-feedback>
                </b-col>
                <b-col cols="12" md="6">
                    <label class="mb-0" for="">Company Reg:</label>
                    <b-form-input v-model="form.company_reg" size="sm" type="text"></b-form-input>
                </b-col>
            </b-row>
            <b-row class="mb-2">
                <b-col cols="12" md="6">
                    <label class="mb-0" for="">VAT No:</label>
                    <b-form-input v-model="form.vat_no" size="sm" type="text"></b-form-input>
                </b-col>
                <b-col cols="12" md="6">
                    <label class="mb-0" for="">Customer No:</label>
                    <b-form-input v-model="form.customer_no" size="sm" type="text"></b-form-input>
                </b-col>
            </b-row>
            <b-row class="mb-2">
                <b-col cols="12" md="6">
                    <label class="mb-0" for="">Email:</label>
                    <b-form-input size="sm" type="text" v-model="form.emails"></b-form-input>
                </b-col>
                <b-col cols="12" md="6">
                    <label class="mb-0" for="">Client Type:</label>
                    <b-form-select
                        id="client-type"
                        name="client-type"
                        v-model="$v.form.type.$model"
                        :options="client_type_select_options"
                        :state="validateState('type')"
                        aria-describedby="client-type-live-feedback"
                        size="sm"
                    ></b-form-select>
                    <b-form-invalid-feedback v-if="formSubmit" id="client-type-live-feedback">This is a required field.</b-form-invalid-feedback>
                </b-col>
            </b-row>
            <b-row class="mb-2">
                <b-col cols="12" md="6">
                    <label class="mb-0" for="">Notification CC:</label>
                    <b-form-input
                        id="notification_cc"
                        size="sm"
                        type="text"
                        v-model="$v.form.notification_cc.$model"
                        :state="validateState('notification_cc')"
                        aria-describedby="notification-cc-live-feedback"
                    ></b-form-input>
                    <b-form-invalid-feedback v-if="formSubmit" id="notification-cc-live-feedback">
                        Please enter a valid email address (leave blank to clear).
                    </b-form-invalid-feedback>
                </b-col>
            </b-row>
            <!-- address section -->
            <b-row class="mb-2">
                <b-col cols="12" md="4">
                    <label class="mb-0" for="">City:</label>
                    <b-form-input
                        id="contact-no"
                        size="sm"
                        type="text"
                        v-model="$v.form.city.$model"
                        :state="validateState('city')"
                        aria-describedby="contact-no-live-feedback"
                    ></b-form-input>
                    <b-form-invalid-feedback v-if="formSubmit" id="contact-no-1-live-feedback"
                        >This is a required field and must be at least 3 characters.</b-form-invalid-feedback
                    >
                </b-col>
                <b-col cols="12" md="4">
                    <label class="mb-0" for="">Postal Code:</label>
                    <b-form-input v-model="$v.form.postal_code.$model" size="sm" type="text" :state="validateState('postal_code')"></b-form-input>
                    <b-form-invalid-feedback v-if="formSubmit" id="ccompany_name-1-live-feedback"
                        >This is a required field and must be at least 3 characters.</b-form-invalid-feedback
                    >
                </b-col>
                <b-col cols="12" md="4">
                    <label class="mb-0" for="">Province:</label>
                    <b-form-select
                        id="client-type"
                        name="client-type"
                        v-model="$v.form.province.$model"
                        :options="client_province_select_options"
                        :state="validateState('province')"
                        aria-describedby="client-type-live-feedback"
                        size="sm"
                    ></b-form-select>
                </b-col>
            </b-row>
            <b-row class="mb-2">
                <b-col>
                    <label class="mb-0" for="">Address:</label>
                    <b-form-textarea v-model="form.address" id="textarea" placeholder="Address" rows="3" max-rows="6"></b-form-textarea>
                </b-col>
            </b-row>
            <div class="modal-footer">
                <div class="d-flex justify-content-between mt-2"></div>
                <b-button v-if="!edit" type="submit" variant="success">Submit</b-button>
                <b-button v-if="edit" type="submit" variant="success">update</b-button>

                <button type="button" class="btn btn-danger" @click="closeModal()">Close</button>
            </div>
        </b-form>
    </b-overlay>
</template>

<script>
//eslint-disable-next-line
import Swal from "sweetalert2";
import { validationMixin } from "vuelidate";
//eslint-disable-next-line
import { required, email, minLength } from "vuelidate/lib/validators";
import { clientMethods, clientComputed } from "@/state/helpers";

export default {
    mixins: [validationMixin],
    props: {
        edit: {
            Boolean,
            required: false,
        },
        clientId: { Number },
    },
    data: () => ({
        formSubmit: false,
        busySaving: false,
        form: {
            id: -1,
            company_name: null,
            type: null,
            contact_person: null,
            contact_no: null,
            company_reg: null,
            vat_no: null,
            customer_no: null,
            address: null,
            emails: null,
            city: null,
            province: null,
            postal_code: null,
            notification_cc: null,
        },
    }),
    validations: {
        form: {
            company_name: {
                required,
                minLength: minLength(3),
            },
            type: {
                required,
            },
            contact_no: {
                required,
                minLength: minLength(3),
            },
            contact_person: {
                required,
                minLength: minLength(3),
            },
            city: {
                required,
            },
            province: {
                required,
            },
            postal_code: {
                required,
            },
            notification_cc: {
                email,
            },
        },
    },
    computed: {
        ...clientComputed,
        client_type_select_options() {
            // need to confirm the details here with api config

            return [
                {
                    value: null,
                    text: "Please select an option",
                    disabled: true,
                },
                { value: "stockist", text: "Stockist" },
                { value: "individual", text: "Individual" },
                { value: "hospitality", text: "Hospitality" },
            ];
        },
        client_province_select_options() {
            // need to confirm the details here with api config

            return [
                {
                    value: null,
                    text: "Please select an option",
                    disabled: true,
                },
                { value: "Western Cape", text: "Western Cape" },
                { value: "Eastern Cape", text: "Eastern Cape" },
                { value: "Free State", text: "Free State" },
                { value: "Gauteng", text: "Gauteng" },
                { value: "KwaZulu-Natal", text: "KwaZulu-Natal" },
                { value: "Limpopo", text: "Limpopo" },
                { value: "Mpumalanga", text: "Mpumalanga" },
                { value: "North-West", text: "North-West" },
                { value: "Northern-Cape", text: "Northern-Cape" },
            ];
        },
    },
    methods: {
        ...clientMethods,
        validateState(name) {
            if (this.formSubmit) {
                const { $dirty, $error } = this.$v.form[name];
                return $dirty ? !$error : null;
            }
        },
        closeModal() {
            this.$bvModal.hide("clientModal");
            this.$bvModal.hide("clientEditModal");
        },
        saveClientForm() {
            this.formSubmit = true;

            this.$v.form.$touch();
            if (this.$v.form.$anyError) {
                return;
            }

            this.busySaving = true;

            if (this.edit) {
                //this will run when the clientEditModal is clicked
                // this.form.id = this.clientId;
                //eslint-disable-next-line
                Swal.fire({
                    title: `Are you sure you would like to update the client details of: ${this.form.company_name}"?`,
                    // text: "You won't be able to undo this!",
                    icon: "warning",
                    showCancelButton: true,
                    confirmButtonColor: "#34c38f",
                    cancelButtonColor: "#f46a6a",
                    confirmButtonText: "Yes, upate!",
                }).then((result) => {
                    if (result.value) {
                        this.saveClient(this.form).then(() => {
                            this.getClients().then(() => {
                                this.busySaving = false;
                                this.$bvModal.hide("clientEditModal");
                                Swal.fire("Client updated!", `${this.form.company_name} was updated.`, "success");
                                //NB: this will refresh the table that stores the clients information
                                this.setSelectedClientDetails({ client_id: this.$route.params.clientid }).then(() => {
                                    this.setFilteredSelectedClientDetails();
                                });
                            });
                        }).catch((error) => {
                            this.busySaving = false;
                            Swal.fire("Save failed", this.saveErrorMessage(error), "error");
                        });
                    } else {
                        this.saveClient(this.form).then(() => {
                            this.getClients().then(() => {
                                this.busySaving = false;
                                this.$bvModal.hide("clientEditModal");
                                Swal.fire("Cancelled", `${this.form.company_name}'s details were not updated!`, "warning");
                            });
                        }).catch((error) => {
                            this.busySaving = false;
                            Swal.fire("Save failed", this.saveErrorMessage(error), "error");
                        });
                    }
                });
            } else {
                this.saveClient(this.form).then(() => {
                    this.getClients().then(() => {
                        this.busySaving = false;
                        this.$bvModal.hide("clientModal");
                        this.$bvModal.hide("clientModal");
                        Swal.fire("Completed", `Client was added`, "success");
                    });
                }).catch((error) => {
                    this.busySaving = false;
                    Swal.fire("Save failed", this.saveErrorMessage(error), "error");
                });
            }
        },
        saveErrorMessage(error) {
            // Surface the server's actual message (e.g. CC email 422, "user email exists" 403)
            // instead of a hardcoded CC error. Falls back to a neutral message.
            return (
                (error && error.response && error.response.data && error.response.data.message) ||
                "Could not save the client. Please check the form and try again."
            );
        },
    },
    mounted() {
        //edit is passed as prop as this page generates two different versions of the same form
        if (this.edit) {
            //id is passed as a prop, otherwise it is set to -1
            this.form.id = this.clientId;
            this.form.company_name = this.selected_client_details.company_name;
            // API returns the type capitalized (ucfirst) for display, but the select
            // options are lowercase — normalize so the dropdown matches an option.
            this.form.type = (this.selected_client_details.type || "").toLowerCase() || null;
            this.form.contact_person = this.selected_client_details.contact_person;
            this.form.contact_no = this.selected_client_details.contact_no;
            this.form.company_reg = this.selected_client_details.company_reg;
            this.form.vat_no = this.selected_client_details.vat_no;
            this.form.customer_no = this.selected_client_details.customer_no;
            this.form.emails = this.selected_client_details.emails;

            this.form.address = this.selected_client_details.address;
            this.form.city = this.selected_client_details.city;
            this.form.province = this.selected_client_details.province;
            this.form.postal_code = this.selected_client_details.postal_code;
            this.form.notification_cc = this.selected_client_details.notification_cc;
        }
    },
};
</script>
